import { render } from "./RateList.vue?vue&type=template&id=2b3bd696&scoped=true"
import script from "./RateList.vue?vue&type=script&lang=js"
export * from "./RateList.vue?vue&type=script&lang=js"

import "./RateList.vue?vue&type=style&index=0&id=2b3bd696&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b3bd696"

export default script